import type { RefObject } from 'react';
import { Button } from '@/components/ui/button';

type FormEditorSectionJumpProps = {
  configurationRef: RefObject<HTMLDivElement | null>;
  previewRef: RefObject<HTMLDivElement | null>;
};

function jumpToSection(section: HTMLDivElement | null) {
  if (!section) return;
  section.focus({ preventScroll: true });
  section.scrollIntoView({ block: 'start', behavior: 'auto' });
}

export default function FormEditorSectionJump({
  configurationRef,
  previewRef,
}: FormEditorSectionJumpProps) {
  return (
    <nav
      aria-label="Jump to form section"
      className="pointer-events-auto sticky top-0 z-20 mb-3 flex shrink-0 gap-2 border-b border-edge bg-white py-2 lg:hidden"
    >
      <Button
        type="button"
        variant="neutral"
        size="workspace"
        aria-label="Jump to editor"
        onClick={() => jumpToSection(configurationRef.current)}
      >
        Edit
      </Button>
      <Button
        type="button"
        variant="neutral"
        size="workspace"
        aria-label="Jump to preview"
        onClick={() => jumpToSection(previewRef.current)}
      >
        Preview
      </Button>
    </nav>
  );
}
